import React from 'react';

export default () => (
  <svg viewBox="0 0 79.227 79.228" width="24px" height="24px" fill="#2f6fbc">
    <path d="M67.639 11.592a39.632 39.632 0 100 56.045 39.676 39.676 0 000-56.045zm-4.325 51.723a33.519 33.519 0 110-47.4 33.557 33.557 0 010 47.4zM24.831 28.888a4.632 4.632 0 114.632 4.633 4.633 4.633 0 01-4.632-4.633zm21 0a4.633 4.633 0 114.634 4.633 4.634 4.634 0 01-4.631-4.633zm10.955 18.971a18.494 18.494 0 01-17.127 10.928A18.366 18.366 0 0122.43 47.8a2.241 2.241 0 114.139-1.718 13.9 13.9 0 0013.09 8.22 14.015 14.015 0 0013.013-8.225 2.241 2.241 0 014.114 1.779z" />
  </svg>
);
